import { ComponentWithAs, Stack, StackProps, forwardRef } from '@chakra-ui/react';

export const StepColorPickerContainer: ComponentWithAs<'div', StackProps> = forwardRef((props, ref) => {
  return <Stack ref={ref} direction='row' w='full' spacing='0' {...props} />;
});
